<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <card>
        <div
          class="col-md-12 col-lg-12 col-sm-12"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <div class="modal-body">
            <div>
              <h4
                slot="header"
                id="modalTitle"
                class="card-title mb-3 text-align-center"
              >
                {{ `${titulo} Kit` }}
              </h4>

              <form id="modalDescription">
                <div class="row">
                  <div class="col-md-6">
                    <base-input
                      type="number"
                      label="Nome (em kWp)"
                      placeholder="kWp"
                      v-model="produto.nome"
                      @input="validaCampos()"
                      @change="validaCampos()"
                    ></base-input>
                  </div>
                  <div class="col-md-6">
                    <base-input
                      type="text"
                      label="Fornecedor"
                      placeholder="Fornecedor"
                      @input="validaCampos()"
                      @change="validaCampos()"
                      v-model="produto.fornecedor"
                    ></base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label for="tecnologia">Tecnologia</label>
                    <select
                      v-model="produto.tipoTecnologia"
                      class="form-control"
                      @input="validaCampos()"
                      @change="validaCampos()"
                    >
                      <option
                        v-for="option in tecnologiaOptions"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      ></option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label for="estrutura">Estrutura</label>
                    <select
                      v-model="produto.tipoEstrutura"
                      class="form-control"
                      @input="validaCampos()"
                      @change="validaCampos()"
                    >
                      <option
                        v-for="option in estruturaOptions"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      ></option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <base-input
                      type="number"
                      label="Valor"
                      placeholder="Valor"
                      @input="validaCampos()"
                      @change="validaCampos()"
                      v-model="produto.valor"
                    ></base-input>
                  </div>
                </div>

                <hr />
                <h5>Módulo</h5>
                <div class="row">
                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="Potência"
                      placeholder="Potência"
                      @input="validaCampos()"
                      @change="validaCampos()"
                      v-model="produto.moduloPotencia"
                    ></base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="Fabricante"
                      placeholder="Fabricante"
                      @input="validaCampos()"
                      @change="validaCampos()"
                      v-model="produto.moduloFabricante"
                    ></base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input
                      type="number"
                      label="Quantidade"
                      placeholder="Quantidade"
                      @input="validaCampos()"
                      @change="validaCampos()"
                      v-model="produto.moduloQuantidade"
                    ></base-input>
                  </div>
                </div>

                <hr />
                <h5>Inversor</h5>
                <div class="row">
                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="Potência"
                      placeholder="Potência"
                      @input="validaCampos()"
                      @change="validaCampos()"
                      v-model="produto.inversorPotencia"
                    ></base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input
                      type="text"
                      label="Fabricante"
                      placeholder="Fabricante"
                      @input="validaCampos()"
                      @change="validaCampos()"
                      v-model="produto.inversorFabricante"
                    ></base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input
                      type="number"
                      label="Quantidade"
                      placeholder="Quantidade"
                      @input="validaCampos()"
                      @change="validaCampos()"
                      v-model="produto.inversorQuantidade"
                    ></base-input>
                  </div>
                </div>

                <hr />
                <div class="row pl-3 align-items-center">
                  <button
                    id="upload_widget"
                    class="d-inline"
                    @click.prevent="uploadImage"
                    v-if="!produto.imagem"
                  >
                    Selecionar imagem
                  </button>
                  <div class="d-inline align-self-center" v-if="produto.imagem">
                    <img
                      :src="produto.imagem"
                      alt="Foto do perfil"
                      id="profile-photo"
                    />
                    <button
                      class="btn btn-icon btn-danger ml-2"
                      @click.prevent="deleteImage()"
                    >
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <button
                    type="submit"
                    class="btn btn-success btn-fill float-right"
                    @click.prevent="salvarProduto"
                    :disabled="erroValidacao"
                  >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Salvar
                  </button>
                  <button
                    @click.prevent
                    class="btn btn-danger btn-fill float-left"
                    @click="close"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i> Fechar
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>
  </transition>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import ProdutosServices from 'src/services/produtos';
import _ from 'lodash';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card
  },
  props: {
    afterCreateAction: Function,
    action: String,
    produto: {
      imagem: '',
      nome: '',
      fornecedor: '',
      tipoTecnologia: '',
      tipoEstrutura: '',
      valor: 0,
      moduloFabricante: '',
      moduloPotencia: '',
      moduloQuantidade: '',
      inversorFabricante: '',
      inversorPotencia: '',
      inversorQuantidade: ''
    }
  },
  data() {
    return {
      notifications: {
        topCenter: false
      },
      simple: '',
      name: 'modal',
      enebledRadio: 'pessoaFisica',
      enebledRadioPermission: '',
      erroValidacao: true,
      estruturaOptions: [
        { value: 'fibrocimento', label: 'Fibrocimento' },
        { value: 'laje', label: 'Laje' },
        { value: 'canal', label: 'Canal' },
        { value: 'metalico', label: 'Metálico' },
        { value: 'solo', label: 'Solo' }
      ],
      tecnologiaOptions: [
        { value: 'inversor-string', label: 'Inversor String' },
        { value: 'micro-inversor', label: 'Microinversor' },
        { value: 'solar-edge', label: 'SolarEdge' }
      ]
    };
  },
  computed: {
    titulo() {
      if (this.action === 'EDIT') {
        return 'Editar';
      } else if (this.action === 'NEW') {
        return 'Cadastrar';
      }
    },
    hasUrlFoto() {
      return this.produto && this.produto.imagem;
    }
  },
  methods: {
    salvarProduto() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Salvo com Sucesso.',
          'fa fa-check'
        );
        this.afterCreateAction();
        this.close();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      if (this.produto._id) {
        ProdutosServices.atualizar(this.produto)
          .then(sucessCallback)
          .catch(errorCallback);
      } else {
        ProdutosServices.salvar(this.produto)
          .then(sucessCallback)
          .catch(errorCallback);
      }
    },
    close() {
      this.$emit('close');
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    uploadImage() {
      // eslint-disable-next-line no-undef
      const myWidget = cloudinary.createUploadWidget(
        {
          cloudName: 'dy8mstmqs',
          uploadPreset: 'afqwmioy',
          sources: ['local'],
          multiple: false,
          maxFiles: 1,
          apiKey: '456183971343259'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.produto.imagem = result.info.url;
            let fornecedor = this.produto.fornecedor;
            this.produto.fornecedor = fornecedor + ' ';
            this.produto.fornecedor = fornecedor;
            this.validaCampos();
          }
        }
      );
      myWidget.open();
    },
    deleteImage() {
      this.produto.imagem = '';
      let fornecedor = this.produto.fornecedor;
      this.produto.fornecedor = fornecedor + ' ';
      this.produto.fornecedor = fornecedor;
    },
    validaCampos() {
      const dadosProduto = Object.values(this.produto);
      const novoDadosProduto = dadosProduto.filter(elemento => {
        if (elemento == '') {
          return false;
        } else return true;
      });
      if (novoDadosProduto.length < 12) {
        this.erroValidacao = true;
      } else this.erroValidacao = false;
    }
  }
};
</script>
<style>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-body {
  position: relative;
}

#profile-photo {
  width: 7em;
  height: 7em;
}

#upload_widget {
  max-height: 30px;
}
</style>
